// CHANGELOG (Reverse chronological order)
// Version 2026100801
// - Add search-first medication entry with optional details and one-step confirmation.
//
// Version 2026100101
// - Collect and confirm patient-reported medication history across PA and insomnia intakes.
export const medicationQuestionVersion = "2026100801";

export default {
  title: "What medications and supplements are you currently taking?",
  description:
    "Search for anything you take or use outside Kick, including prescriptions, over-the-counter medicines, vitamins, supplements, and topical creams. Include inhalers, injections, and patches. Do not include medications prescribed by Kick.",
  code: "external-medications",
  type: "medication-review",
};
